<script>
	import { api } from "../api";
	import { ChevronRightIcon } from "svelte-feather-icons";
	import formatRelative from "date-fns/formatRelative";
	import Device from "../components/Device.svelte";
	import FilterBar from "../components/FilterBar.svelte";
	import { navigate } from "svelte-navigator";
	import DeviceImage from "../components/DeviceImage.svelte";
  import DeviceStatusImage from "../components/DeviceStatusImage.svelte";

	export let selectedId;

	let filter = "";

	const tabTypes = ["GRS", "ARS", "SRS"];

	const devices = api.devices.store;

	// TODO:  Store this in user local storage as a preference
	let hideOffline = false
	let hideDecommissioned = true
	let hideAttached = true

	let settingsOpen = false;

	let manualTab = false;
	$: curTabType =
		!manualTab && $devices[selectedId]
			? $devices[selectedId].type
			: curTabType || "GRS";

	$: if ($devices[selectedId] && $devices[selectedId].parentDeviceId && hideAttached) {
		hideAttached = false
	}

	$: sorted = Object.values($devices)
		.sort((a, b) => {
			const aActive = a.state !== "DISCONNECTED";
			const bActive = b.state !== "DISCONNECTED";
			if (aActive == bActive) {
				return a.name.localeCompare(b.name);
			}
			if (aActive) return -1;
			return 1;
		})
		.filter((d) => d.type === curTabType)
		.filter((d) => {
			if (curTabType === "GRS") {
				if (hideOffline && d.state === "DISCONNECTED") return false
				if (hideDecommissioned && d.state === "DECOMMISSIONED") return false
			} else {
				if (hideAttached && d.parentDeviceId) return false
			}
			return true;
		})
		.filter(
			(d) =>
				d.name.toLowerCase().includes(filter.toLowerCase()) ||
				d.radioId.toLowerCase().includes(filter.toLowerCase()) ||
				d.id.toString().includes(filter)
		);

	function allPromises() {
		return Promise.all([api.devices.get()]);
	}

	function entryClicked(id) {
		navigate(`/devices/${id}`, { replace: true });
		showNew = false;
	}

	function setTab(tabName) {
		curTabType = tabName;
		manualTab = true;
	}

	let showNew;

	function closeDeviceSidebar() {
		selectedId = null;
		navigate(`/devices`, { replace: true });
	}

	function settingsClicked() {
		settingsOpen = !settingsOpen;
	}
</script>

<svelte:head>
	<title>SkyLine - Devices</title>
</svelte:head>

{#await allPromises() then _}
	<div class="devices">
		<header>
			<div class="filterTabContainer">
				<div class="typeFilters">
					{#each tabTypes as tabName}
						<div
							class="tab"
							class:selected={curTabType === tabName}
							on:click={() => setTab(tabName)}
						>
							{tabName}
						</div>
					{/each}
				</div>
				<FilterBar bind:filter on:new={() => (showNew = true)} />
				<div class="settingsContainer">
					<img src="/images/settings-2.svg" alt="Settings slider icon" width="24 px" height="24 px" on:click={settingsClicked} />
				</div>
			</div>
			
			{#if curTabType !== "ARS"}
			<div  class={`hideOffline ${settingsOpen ? 'mobileSettings' : ''}`}>
				<div>
					<label><input type="checkbox" bind:checked={hideOffline} />Hide Offline</label>
				</div>
				<div>
					<label><input type='checkbox' bind:checked={hideDecommissioned} />Hide Decommissioned</label>
				</div>
			</div>
			{:else}
			<div class={`hideOffline ${settingsOpen ? 'mobileSettings' : ''}`}>
				<div>
					<label><input type="checkbox" bind:checked={hideAttached} />Hide Attached</label>
				</div>
			</div>
			{/if}
		</header>
		<div class="listContainer">
			<table class="deviceList">
				<thead class="deviceEntry">
					<tr class="deviceListHeader">
						<th class="deviceIconSpacer" />
						<th class="deviceName">Name</th>
						<th class="infoRadioId">RadioId</th>
						<th class="infoDeviceId">Id</th>
						<th>State</th>
						<th>Updated</th>
						<th class="deviceConnectedSpacer" />
					</tr>
				</thead>
				<tbody>
					{#each sorted as device (device.id)}
						<tr
							class={"deviceEntry " + device.state.toLowerCase()}
							class:selected={device.id == selectedId}
							on:click={() => entryClicked(device.id)}
						>
							<td class="deviceIconSpacer">
								<DeviceImage {device} />
							</td>
							<td class={`deviceName ${(device.name === device.radioId) ? "" : "nameAlignment"}`}>{device.name} {#if device.parentDeviceId}(attached to {$devices[device.parentDeviceId].name}){/if}</td>
							<td class={`infoRadioId ${(device.name === device.radioId) ? "hiddenOnMobile" : "infoRadioIdAlignment"}`}>{device.radioId}</td>
							<td class="infoDeviceId">{device.id}</td>
							<td class="state hiddenOnMobile">{device.state}</td>
							<td class="state hiddenOnDesktop"><DeviceStatusImage {device} /></td>
							<td class="updated"
								>{formatRelative(new Date(device.updatedAt), new Date())}</td
							>
							<td>
								{#if device.id == selectedId}
									<ChevronRightIcon />
								{/if}
							</td>
						</tr>
					{:else}
						<tr
							><td colspan="7" class="noDevices"
								>No devices found, check filters and registration.</td
							></tr
						>
					{/each}
				</tbody>
			</table>
		</div>
		<div class={`device ${(showNew || $devices[selectedId]) ? 'open' : ''}`}>
			{#if showNew || $devices[selectedId]}
				<Device
					device={showNew ? null : $devices[selectedId]}
					on:close={closeDeviceSidebar}
					on:canceled={() => (showNew = false)}
				/>
			{/if}
		</div>
	</div>
{/await}

<style>
	.hiddenOnMobile {
		display: table-cell;
	}

	.hiddenOnDesktop {
		display: none;
	}
	.deviceEntry img {
		height: 30px;
	}
	img.grs {
		padding: 4px;
		padding-top: 6px;
	}
	img.grs.active {
		background: rgb(2 154 1);
		background: radial-gradient(
			circle,
			rgb(2 154 1) 0%,
			rgba(20, 255, 0, 0) 65%
		);
	}
	.devices {
		display: grid;
		grid-template-columns: minmax(0, 3fr) auto;
		grid-template-rows: auto 1fr;
	}

	header {
		display: flex;
		align-items: center;
		background-color: gray;
		padding: 8px;
	}

	.settingsContainer {
		display: none;
	}


	.listContainer {
		grid-row: 2;
		overflow: auto;
		background: grey;
	}
	.deviceList {
		width: 100%;
		border-collapse: collapse;
	}

	th {
		text-align: right;
	}
	td {
		text-align: right;
	}

	.device {
		grid-row: span 2;
		height: 100%;
	}
	.deviceEntry {
		cursor: pointer;
		color: black;
		background: lightgray;
		/* padding: 1rem; */
		border-bottom: 1px solid #e3e3e3;
	}

	.deviceEntry div {
		flex: 25%;
	}

	.deviceEntry:not(.deviceListHeader):hover {
		background-color: rgb(180, 180, 180);
	}

	.deviceEntry.selected,
	.deviceEntry.selected:hover {
		background: white;
	}

	.deviceEntry img {
		margin: 4px;
	}

	.deviceName {
		margin-left: 4px;
		font-weight: bold;
		font-size: 10pt;
		text-align: left;
	}

	.deviceEntry.disconnected {
		color: #505050;
	}

	.deviceListHeader {
		border-top: 1px solid lightgray;
		border-bottom: 2px dotted gray;
		font-weight: bold;
		font-size: 11pt;
		background-color: lightgray;
		cursor: initial;
		top: 0;
	}

	.deviceIconSpacer {
		width: 30px;
	}

	.deviceView {
		max-width: 500px;
		margin: auto;
	}

	.filterTabContainer {
		display: flex;

	}

	.typeFilters {
		background-color: lightgray;
		display: flex;
		border-radius: 8px;
		margin-right: 8px;
		overflow: hidden;
		user-select: none;
	}

	.tab {
		padding: 8px;
		width: 80px;
		text-align: center;
		cursor: pointer;
	}

	.tab.selected {
		background-color: white;
	}

	.typeFilters > div:not(:last-child) {
		border-right: 1px solid darkgrey;
	}

	.noDevices {
		text-align: center;
		font-style: italic;
		font-size: 12pt;
		margin: 2em;
		font-weight: bold;
		background-color: lightgray;
		padding: 8px;
	}

	.updated {
		text-transform: capitalize;
	}

	.hideOffline {
		flex: 1;
		text-align: right;
		color: white;
	}

	.hideOffline input {
		margin-right: 4px;
	}

	@media only screen and (max-width: 600px) {
		
		header {
			flex-wrap: wrap;
			padding-top: 25px;
		}

		.filterTabContainer {
			display: flex;

		}

		.settingsContainer {
			display: flex;
    	align-items: center;
			margin-left: 5px;
		}

		.mobileSettings {
			display: flex !important; 
		}

		.hideOffline {
			display: none;
			justify-content: space-around;
			margin-top: 10px;
		}
		.hideOffline input {
			margin-right: 8px;
			height: 20px;
			width: 20px;
		}


		label {
			display: flex;
			align-items: center;
			text-transform: uppercase;
		}

		.device {
			position: fixed;
			top: 0;
			left: -300px;
			width: 300px;
			height: 100vh;
			background-color: #f0f0f0;
			transition: transform 0.3s ease-out;
		}

		.device.open {
			transform: translateX(300px);
		}

		.deviceName {
			margin-left: 0px;
			width: 50%;
		}

		table {
    	border: 0;
  	}

		table th {
			display: none;
		}

		table td {
			padding: 0.625em;
		}

		table thead {
			border: none;
			clip: rect(0 0 0 0);
			height: 1px;
			margin: -1px;
			overflow: hidden;
			padding: 0;
			position: absolute;
			width: 1px;
		}

		table tr {
			border-bottom: 3px solid #d3d3d3;
			display: flex;
    	align-items: center;
			flex-wrap: wrap;
		}

		table td {
			border-bottom: 0px solid #d3d3d3;
		}


		.deviceIconSpacer {
			width: 10%;
		}

		.nameAlignment {
			margin-top: -13px;
		}

		.infoRadioId {
			display: block;
			order: 4;
			text-align: left;
			margin-top: -20px;
			margin-left: 11%;
			font-size: 10px;
		}

		.infoRadioIdAlignment {
			margin-top: -33px;
		}


		.state {
			order: 3;
			width: 36%;
		}

		.infoDeviceId {
			display: none;
		}
		.updated {
			display: none;
		}

		.hiddenOnMobile {
			display: none;
		}
		.hiddenOnDesktop {
			display: table-cell;
		}

			
	}

	@media only screen and (max-width: 375px) { 
		.deviceName {
			width: 49%;
		}
}

</style>
